import 'firebase/compat/firestore';
import { ArtistId, ArtistMeta } from "../models/Artist";
import { ArtistRef } from "../models/Directory";
import 'firebase/compat/firestore';
import firebase from "firebase/compat/app";
const firestore = firebase.firestore


export class DirectoryService {


    static updateArtist(artist: ArtistMeta) {
        var db = firestore();
        db.collection("artists").doc(artist.id).set(artist);
    }
    static fetch(artistId: ArtistId): Promise<ArtistRef> {
        return new Promise((resolve, reject) => {
            var db = firestore();
            const directoryEntryRef = db.collection("artists").doc(artistId);
            directoryEntryRef.get().then((directoryEntryDoc) => {
                const entry = DirectoryService.StronglyTypeArtistRefData(directoryEntryDoc)
                resolve(entry);
            }).catch(reject)
        });
    }

    static fetchMany(artistId: ArtistId[]): Promise<ArtistRef[]> {
        return new Promise((resolve, reject) => {
            var db = firestore();
            const directoryEntriesRef = db.collection("artists").where(firestore.FieldPath.documentId(), "in", artistId);
            directoryEntriesRef.get().then((directoryEntriesCollection) => {
                let matches: ArtistRef[] = [];
                for (const directoryEntryDoc of directoryEntriesCollection.docs) {
                    const entry = DirectoryService.StronglyTypeArtistRefData(directoryEntryDoc)
                    matches.push(entry);
                }
                resolve(matches);
            }).catch(reject)
        });
    }
    static fetchSome(pageSize: number, cursor: number, field: string): Promise<ArtistRef[]> {
        return new Promise((resolve, reject) => {
            var db = firestore();
            const directoryEntriesRef = db.collection("artists").orderBy("songs", "desc").startAfter(cursor).limit(pageSize);
            directoryEntriesRef.get().then((directoryEntriesCollection) => {
                let matches: ArtistRef[] = [];
                for (const directoryEntryDoc of directoryEntriesCollection.docs) {
                    const entry = DirectoryService.StronglyTypeArtistRefData(directoryEntryDoc)
                    matches.push(entry);
                }
                resolve(matches);
            }).catch(reject)
        });
    }

    /**
     * Paginated fetch ordered by `songs` desc, gated by `songs > 0`.
     * Pass the previous page's last `songs` value as `afterSongs` to get the next page.
     * Pass undefined for the first page.
     */
    static fetchPage(pageSize: number, afterSongs?: number): Promise<ArtistRef[]> {
        return new Promise((resolve, reject) => {
            const db = firestore();
            let q: firebase.firestore.Query = db.collection("artists")
                .where("songs", ">", 0)
                .orderBy("songs", "desc");
            if (typeof afterSongs === 'number') {
                q = q.startAfter(afterSongs);
            }
            q.limit(pageSize).get().then((snap) => {
                const matches: ArtistRef[] = [];
                for (const doc of snap.docs) {
                    matches.push(DirectoryService.StronglyTypeArtistRefData(doc));
                }
                resolve(matches);
            }).catch(reject);
        });
    }

    /**
     * Snapshot listener scoped to the top `pageSize` artists by `songs` desc.
     * Used to keep the visible ranking fresh without downloading the whole
     * directory. Returns the unsubscribe function.
     */
    static observeTop(pageSize: number, onChange: (artists: ArtistRef[]) => void): () => void {
        const db = firestore();
        return db.collection("artists")
            .where("songs", ">", 0)
            .orderBy("songs", "desc")
            .limit(pageSize)
            .onSnapshot((snap) => {
                const matches: ArtistRef[] = [];
                for (const doc of snap.docs) {
                    matches.push(DirectoryService.StronglyTypeArtistRefData(doc));
                }
                onChange(matches);
            });
    }
    static fetchAll(): Promise<ArtistRef[]> {
        return new Promise((resolve, reject) => {
            var db = firestore();
            const directoryEntriesRef = db.collection("artists");
            directoryEntriesRef.get().then((directoryEntriesCollection) => {
                let matches: ArtistRef[] = [];
                for (const directoryEntryDoc of directoryEntriesCollection.docs) {
                    const entry = DirectoryService.StronglyTypeArtistRefData(directoryEntryDoc)
                    matches.push(entry);
                }
                resolve(matches);
            }).catch(reject)
        });
    }


    static observe(onArtistsChange: (artists: ArtistRef[]) => void): void {
        var db = firestore();
        const directoryEntriesRef = db.collection("artists").orderBy("songs", "desc").where("songs", ">", 0);
        directoryEntriesRef.onSnapshot((directoryEntriesCollection) => {
            let matches: ArtistRef[] = [];
            for (const directoryEntryDoc of directoryEntriesCollection.docs) {
                const entry = DirectoryService.StronglyTypeArtistRefData(directoryEntryDoc)
                matches.push(entry);
            }
            onArtistsChange(matches);
        });
    }





    static StronglyTypeArtistRefData = (artistDoc: firebase.firestore.QueryDocumentSnapshot<firebase.firestore.DocumentData> | firebase.firestore.DocumentSnapshot<firebase.firestore.DocumentData>) => {
        const artist_data = { ...artistDoc.data(), id: artistDoc.id } as ArtistRef;
        return artist_data;
    }

}